import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function ShopfloorScreen() {
  return (
    <ScreenFrame
      title="Shopfloor"
      actions={
        <>
          <Button component={Link} to="/prototype/production-start" variant="outlined" size="small">Production start</Button>
          <Button component={Link} to="/prototype/receive-goods" variant="outlined" size="small">Receive goods</Button>
        </>
      }
    >
      <Typography color="text.secondary" paragraph>Mobile-friendly shopfloor view. Scan and production actions.</Typography>
      <Button component={Link} to="/prototype/production-orders" variant="contained">Production orders</Button>
    </ScreenFrame>
  );
}
